import styled from 'styled-components';
import { Link } from 'gatsby';
import activeClassName from './active-classname';

export default styled(Link)`
  font-family: ${(props) => props.theme.standoutFontFamily};
  text-transform: uppercase;
  color: ${(props) => props.theme.fontColor};
  text-decoration: none;
  padding: 10px ${(props) => props.theme.grid.gap};
  font-weight: 700;
  display: block;
  @media all and (min-width: ${(props) => props.theme.breakingpoints.xl}) {
    padding: 20px;
  }
  &:hover,
  &.${activeClassName} {
    color: ${(props) => props.theme.primaryColor};
  }
`;
